<template>
  <b-row>
    <b-col md="12">
      <!-- Alert: No item found -->
      <b-alert
        variant="danger"
        :show="errorMessage !== ''"
      >
        <h4 class="alert-heading">
          {{ errorMessage }}
        </h4>
      </b-alert>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class=""
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <div
            data-v-aa799a9e=""
            class="d-flex mb-1"
          >
            <div
              class="custom-control custom-radio"
            >
              <input
                id="social_fb"
                v-model="itemData.type_social"
                type="radio"
                name="some-radios"
                class="custom-control-input"
                value="10"
              ><label
                class="custom-control-label"
                for="social_fb"
              > Facebook </label>
            </div>
            <div
              class="custom-control custom-radio ml-1"
            >
              <input
                id="social_ytb"
                v-model="itemData.type_social"
                type="radio"
                name="some-radios"
                class="custom-control-input"
                value="20"
                @input="checkAuthenGoogle(20)"
              ><label
                class="custom-control-label"
                for="social_ytb"
              > Youtube </label>
            </div>
            <div
              class="custom-control custom-radio ml-1"
            >
              <input
                id="social_twitter"
                v-model="itemData.type_social"
                type="radio"
                name="some-radios"
                class="custom-control-input"
                value="30"
              ><label
                class="custom-control-label"
                for="social_twitter"
              > Twitter </label>
            </div>
            <div
              class="custom-control custom-radio ml-1"
            >
              <input
                id="social_twitch"
                v-model="itemData.type_social"
                type="radio"
                name="some-radios"
                class="custom-control-input"
                value="40"
              ><label
                class="custom-control-label"
                for="social_twitch"
              > Twitch.tv </label>
            </div>
          </div>
          <div
            v-if="itemData.type_social == 10"
            class="col-12"
          >
            <validation-provider

              #default="validationContext"
              name="Nội dung bài viết"
              rules="required"
            >
              <b-form-group>
                <template #label>
                  <label
                    class="d-block font-weight-bolder"
                  >Nội dung <span class="text-danger">*</span></label>
                </template>
                <b-form-textarea
                  id="textarea"
                  v-model="itemData.content"
                  placeholder="Nhập nội dung..."
                  rows="3"
                  max-rows="10"
                  max="420"
                  :state="getValidationState(validationContext)"

                  @input="check"
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
              <p :class="{help: true, 'text-danger': remaining==0}">
                {{ instruction }}
              </p>
            </validation-provider>

            <b-form-group>
              <template #label>
                <label
                  class="d-block font-weight-bolder"
                >Link liên kết</label>
              </template>
              <b-form-input
                id="textarea"
                v-model="itemData.link"
                placeholder="Nhập link..."
              />

            </b-form-group>
            <b-form-group>
              <template #label>
                <label
                  class="d-block font-weight-bolder"
                >Link ảnh</label>
              </template>
              <b-form-input
                id="textarea"
                v-model="itemData.link_image"
                placeholder="Nhập link ảnh..."
              />

            </b-form-group>
          </div>
          <!-- Youtube -->
          <div
            v-else-if="itemData.type_social == 20"
            class="col-12"
          >
            <div
              v-if="isValidGoogle === false"
              class="col-12 mb-1 offset-1"
            >
              <button
                type="button"
                class="btn btn-sm btn-primary"
                @click="oauthSignIn"
              >
                Đăng nhập google
              </button>
            </div>
            <div v-else>
              <b-form-group>
                <template #label>
                  <label
                    class="d-block font-weight-bolder"
                  >Tiêu đề</label>
                </template>
                <b-form-input
                  id="textarea"
                  v-model="itemData.title"
                  placeholder="Nhập tiêu đề..."
                  rows="1"
                />
              </b-form-group>
              <b-form-group>
                <template #label>
                  <label
                    class="d-block font-weight-bolder"
                  >Mô tả</label>
                </template>
                <b-form-input
                  id="textarea"
                  v-model="itemData.description"
                  placeholder="Nhập mô tả..."
                  rows="1"
                />
              </b-form-group>
              <validation-provider
                #default="validationContext"
                name="Link"
                rules="required"
              >
                <b-form-group>
                  <template #label>
                    <label
                      class="d-block font-weight-bolder"
                    >Link<span class="text-danger">*</span></label>
                  </template>
                  <b-form-textarea
                    id="textarea"
                    v-model="itemData.content"
                    placeholder="Nhập link..."
                    rows="1"
                    :state="getValidationState(validationContext)"
                  />

                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>

              </validation-provider>
            </div>

          </div>
          <div
            v-else
            class="col-12"
          >
            <validation-provider
              #default="validationContext"
              name="Link"
              rules="required"
            >
              <b-form-group>
                <template #label>
                  <label
                    class="d-block font-weight-bolder"
                  >Link<span class="text-danger">*</span></label>
                </template>
                <b-form-textarea
                  id="textarea"
                  v-model="itemData.content"
                  placeholder="Nhập link..."
                  rows="1"
                  :state="getValidationState(validationContext)"
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>

            </validation-provider>
          </div>

          <!--  Hẹn giờ xuất bản -->
          <div class="col-12">

            <b-form-group>
              <b-form-checkbox
                v-model="itemData.is_timer"
                class="checkboxLabel"
                value="1"
              > Hẹn giờ xuất bản </b-form-checkbox>
            </b-form-group>
            <b-form-group>
              <flat-pickr
                v-model="itemData.published_at"
                class="form-control"
                :disabled="!itemData.is_timer"
                :config="configDate"
                placeholder="dd/mm/yyyy hh:mm"
              />
            </b-form-group>
          </div>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              :disabled="disabledBtn"
              type="submit"
            >
              <span>{{ $t('Save') }}</span>
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BAlert,
  BOverlay,
  BForm,
  BFormGroup,
  BButton,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormTextarea,
  BCardText,
  BFormSelect,
} from 'bootstrap-vue';
import { ref } from '@vue/composition-api';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, alphaNumDot, max } from '@validations';
import Ripple from 'vue-ripple-directive';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue';

import flatPickr from 'vue-flatpickr-component';
import { Vietnamese } from 'flatpickr/dist/l10n/vn';
import vSelect from 'vue-select';
import formValidation from '@core/comp-functions/forms/form-validation';
import { useRouter, showToast } from '@core/utils/utils';
import store from '@/store';

export default {
  components: {
    AppBreadcrumb,
    BRow,
    BCol,
    BCard,
    BCardText,
    BAlert,
    BOverlay,
    BForm,
    BFormGroup,
    BButton,
    BFormInput,
    BFormTextarea,
    BFormInvalidFeedback,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    vSelect,
    flatPickr,
  },
  directives: {
    Ripple,
  },
  props: {
    mdata: Object,
  },
  data() {
    return {
      required,
      alphaNumDot,
      max,
      limit: 420,
      isValidGoogle: false,
    };
  },
  computed: {
    instruction() {
      return this.itemData.content === ''
        ? `Giới hạn ${this.limit} ký tự`
        : `Còn lại ${this.remaining} ký tự`;
    },
    remaining() {
      return this.limit - this.itemData.content.length;
    },
  },
  mounted() {},
  methods: {
    check() {
      this.itemData.content = this.itemData.content.substr(0, this.limit)
    },
    checkAuthenGoogle(item) {
      if (item === 20) {
        store
          .dispatch('social/checkAuthenGoogle')
          .then((response) => {
            console.log(response);
            if (response.status === 200) {
              if (response.data.code === 200) {
                if (response.data.data.is_valid === true) {
                  this.isValidGoogle = true;
                } else {
                  this.isValidGoogle = false
                }
              } else {
                this.isValidGoogle = false
              }
            }
          });
      }
    },
  },

  setup(props, { emit }) {
    const { route, router } = useRouter();
    const id = ref(
      route.value.params.id !== undefined ? route.value.params.id : 0,
    );
    const errorMessage = ref('');
    const disabledBtn = ref(false);
    const defaultItemData = {
      content: '',
      type_social: 10,
      is_timer: null,
      published_at: '',
    };
    const itemData = ref(JSON.parse(JSON.stringify(defaultItemData)));

    const resetItemData = () => {
      itemData.value = JSON.parse(JSON.stringify(defaultItemData));
    };
    const { refFormObserver, getValidationState, resetForm } = formValidation(resetItemData);

    const onSubmit = () => {
      errorMessage.value = '';
      disabledBtn.value = true;
      console.log('itemData', itemData)
      itemData.value.type_social = +itemData.value.type_social
      itemData.value.is_timer = +itemData.value.is_timer
      store
        .dispatch('social/createFacebook', itemData.value)
        .then((response) => {
          if (response.status === 200) {
            disabledBtn.value = false;
            if (response.data.code === 200) {
              showToast(response.data.message, { variant: 'success' });
              resetForm();
              emit('updateData');
            } else {
              showToast(response.data.message);
              errorMessage.value = response.data.message;
            }
          } else {
            disabledBtn.value = false;
          }
        });
    };
    const oauthSignIn = () => {
      const urlPlan = (process.env.VUE_APP_PLAN_API_URL).replace('api/', '');
      console.log(urlPlan);
      // Google's OAuth 2.0 endpoint for requesting an access token
      const oauth2Endpoint = `${urlPlan}youtube/auth`;

      // Create <form> element to submit parameters to OAuth 2.0 endpoint.
      const form = document.createElement('form');
      form.setAttribute('method', 'GET'); // Send as a GET request.
      form.setAttribute('action', oauth2Endpoint);

      // // Parameters to pass to OAuth 2.0 endpoint.
      // const params = {
      //   client_id: '47935080789-mbirbrpkflv08evis381spspupq229j5.apps.googleusercontent.com',
      //   redirect_uri: `${urlPlan}youtube/callback`,
      //   response_type: 'token',
      //   scope: 'https://www.googleapis.com/auth/youtube.force-ssl',
      //   include_granted_scopes: 'true',
      //   state: 'pass-through value',
      // };

      // // Add form parameters as hidden input values.
      // for (const p in params) {
      //   const input = document.createElement('input');
      //   input.setAttribute('type', 'hidden');
      //   input.setAttribute('name', p);
      //   input.setAttribute('value', params[p]);
      //   form.appendChild(input);
      // }

      // Add form to page and submit it to open the OAuth 2.0 endpoint.
      document.body.appendChild(form);
      form.submit();
    }

    Vietnamese.rangeSeparator = ' - ';
    const configDate = ref({
      dateFormat: 'd/m/Y H:i',
      wrap: true,
      enableTime: true,
      time_24hr: true,
      defaultHour: new Date().getHours(),
      defaultMinute: new Date().getMinutes(),
      locale: Vietnamese, // locale for this instance onlyf
    });

    return {
      id,
      errorMessage,
      itemData,
      refFormObserver,
      getValidationState,
      resetForm,
      resetItemData,
      onSubmit,
      disabledBtn,
      configDate,
      oauthSignIn,
    };
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
